module.exports = __webpack_public_path__ + "static/image3-7baa4c58c7cb6df23255af66fc8f6f64.png";